import React from "react";
import { connect } from "react-redux";
import {
  guardarAplicacionExterna,
  editarAplicacionExterna,
} from "../../components/aplicacionExterna/AplicacionExternaService";
import {
  URL,
  getAuthorizationHeader,
  idEmpresa,
  getAuthorizationHeaderUpload,
} from "../../constans/constants";
import { exportarDocumento } from "../lotes/LoteService";
import axios from "axios";
import { logout } from "../login/SesionService"
import { getUsuario } from "../usuario/UsuarioService";
import { validateForm } from "../../constans/validationUtils";
import DropzoneComponent from "../componentes/DropzoneComponent";
import BreadCrumComponent from "../componentes/BreadCrumComponent";
import AsignarColaboradoresGrupos from "./AsignarColaboradoresGrupos";
import {
  mostrarErroresEnFormulario, configurarLimpiezaAutomatica,
  integrarConHandleInput, limpiarErrorCampo
} from '../../constans/form-error-utils';;

class ImportarDocumento extends React.Component {
  constructor(props) {
    super(props);
    const today = new Date(),
      date =
        today.getDate() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getFullYear();

    const originalHandleInput = this.handleInput;

    this.handleInput = integrarConHandleInput(this, originalHandleInput);

    this.state = {
      descripcion: "",
      numeroPatronal: [],
      gruposUsuarios: [],
      tipoDocumento: [],
      lote: [],
      id: "",
      date: date,
      archivoLote: null,
      uploadDisabled: false,
      numeroPatronalID: "",
      tipoDocumentoID: "",
      formatoTipoDocumentoSeleccionado: "",
      idGrupo: "",
      isCarpetaPorDefecto: false,
      carpetaPorDefecto: "",
      fileErrorMsg: "",
      errors: {
        descripcion: null,
        numeroPatronalID: null,
        tipoDocumentoID: null,
        idGrupo: null,
        carpetaPorDefecto: null,
        idColaborador: null,
      },
      path: "",
      mensaje: "",
      severity: "",
      mostrarMensajeFlash: false,
      submit: false,
      openPantallaCarga: false,
      requiredNroMtess: false,
      grupoCheckBox: false,
      idColaborador: null,
      usuarioData: {},
      hayDatosUsuario: false,
      mensajeConsultaUsuario: "",
      cedula: "",
      mostrarAsignacion: false,
      nombreArchivo: null,
      pesoArchivoMb: null,
      listaArchivosPermitidos: ['xml', 'pdf'],
      showErrors: false

    };
  }

  reglasValidacionCampos = {
    descripcion: [
      { required: true, message: 'Debe proveer una descripcion para el lote' },
      {
        customValidator: (value, formData) => {
          return value.length < 251
        }, message: 'La cantidad maxima de caracteres es de 250'
      }
    ],
    tipoDocumentoID: [
      {
        customValidator: (value, formData) => {
          return value > 0
        }, message: 'Debe seleccionar un tipo de documento'
      },
    ],
    numeroPatronalID: [
      {
        customValidator: (value, formData) => {
          if (!this.validarExtensionDocumento())
            return true
          else
            return value > 0
        }, message: 'Debe elegir una opcion'
      },
    ],
    carpetaPorDefecto: [
      {
        customValidator: (value, formData) => {
          if (!this.state.isCarpetaPorDefecto)
            return true
          else
            return /^(\/[^\/]+)+$/.test(value)
        }, message: 'Ingrese una direccion valida'
      },
    ],
    idColaborador: [
      { required: true, message: 'Ingrese un numero de cedula' },
      { customValidator: (value, formData) => /^\d+$/.test(value), message: 'Ingrese sólo números' },
    ],
    archivoLote: [
      { required: true, message: 'Debe cargar un documento' },
      {
        allowedExtensions: (formData) => {
          let extensions = formData.listaArchivosPermitidos;
          return extensions;
        },
        message: 'Archivo no permitido según tipo documento elegido'
      },
      {
        allowedMimeTypes: (formData) => {
          const formatoSeleccionado = formData.formatoTipoDocumentoSeleccionado.toLowerCase();
          if (formatoSeleccionado === 'xml') {
            return ['application/xml'];
          }
          if (formatoSeleccionado === 'pdf') {
            return ['application/pdf'];
          }
          return [];
        },
        message: 'Tipo de archivo no permitido'
      }
    ]
  }

  checkFileExtension = (tiposDocumentos, documentoSeleccionado) => {
    const fileName = this.state.archivoLote.name
    const extension = fileName.substring(fileName.lastIndexOf('.') + 1);
    const formatoTipoDocumento = tiposDocumentos.find((aux) => aux.id == documentoSeleccionado)
    if (extension.toLowerCase() === formatoTipoDocumento.formato.toLowerCase())
      return formatoTipoDocumento.formato.toLowerCase();
    return null;
  }


  manejarResultadoSubidaArchivos = (resultado) => {

    this.setState({ openPantallaCarga: false })
    let resultados = {}
    const grupo = this.state.usuarioData;
    const nombreCompleto = grupo?.nombreApellido ?? "";
    if (resultado.error) {
      resultados = {
        nombreDocumento: this.state.descripcion,
        destinatario: nombreCompleto,
        errorDetalle: [],
        backURL: this.props.location.pathname,
        urlSiguiente: this.props.location.pathname,
      };
      resultados.errorDetalle.push(resultado.mensaje)
      this.props.history.push({
        pathname: '/documento/import/error',
        state: resultados
      });
    } else {


      this.props.history.push({
        pathname: '/documento/import/exito',
        state: {
          nombreDocumento: this.state.descripcion,
          destinatario: nombreCompleto,
          errorDetalle: resultado.datos.errors,
          backURL: this.props.location.pathname,
          urlSiguiente: '/lote/recibos/nuevo/' + resultado.datos.batchId
        }
      })
    }



  }

  confirmarColaborador = (data) => {
    this.setState({ idColaborador: data.cedula, usuarioData: data, mostrarAsignacion: false })
  }

  subirArchivo = event => {
    event.preventDefault();
    const { isValid, errors } = validateForm(this.state, this.reglasValidacionCampos);
    if (isValid) {
      mostrarErroresEnFormulario({})
      const data = {
        description: this.state.descripcion,
        file: null,
        filename: this.state.nombreArchivo,
        empresaId: idEmpresa(),
        numeroPatronalId: this.state.numeroPatronalID,
        documentTypeId: this.state.tipoDocumentoID,
        serverFolder: this.state.carpetaPorDefecto,
        idColaborador: this.state.usuarioData.id
      }
      if (this.state.uploadDisabled) {
        axios
          .post(URL + "lote/import/form/server", data, getAuthorizationHeader())
          .then((res) => {
            this.manejarResultadoSubidaArchivos(res.data)
          }, error => {
            if (error.response.status === 401) {
              logout();
            }
            return error;
          });
      } else {
        this.setState({ openPantallaCarga: true });
        let formData = new FormData();
        formData.append("file", this.state.archivoLote);
        axios
          .post(URL + "recibo/upload/" + this.state.formatoTipoDocumentoSeleccionado.toLowerCase(), formData, getAuthorizationHeaderUpload())
          .then((res) => {
            if (res.data.error == false) {
              data.file = res.data.datos;
              axios
                .post(URL + "recibo/importarDocumento", data, getAuthorizationHeader())
                .then((res) => {
                  this.manejarResultadoSubidaArchivos(res.data)
                }, error => {
                  if (error.response.status === 401) {
                    logout();
                  }
                  return error;
                });
            } else {
              this.manejarResultadoSubidaArchivos(res.data)
            }
          });
      }
    } else {
      this.setState({ errors: errors, showErrors: true });
      mostrarErroresEnFormulario(errors);
    }
  };


  componentDidMount() {

    configurarLimpiezaAutomatica()

    axios
      .get(
        URL + "tipoDocumento/listar/" + idEmpresa(),
        getAuthorizationHeader()
      )
      .then((res) => {
        if (res.data.error == false) {
          this.setState({ tipoDocumento: res.data.datos });
        }
      }, error => {
        if (error.response.status === 401) {
          logout();
        }
        return error;
      });
    axios
      .get(
        URL + "numeroPatronal/listar/" + idEmpresa(),
        getAuthorizationHeader()
      )
      .then((res) => {
        if (res.data.error == false) {
          this.setState({ numeroPatronal: res.data.datos });
        }
      }, error => {
        if (error.response.status === 401) {
          logout();
        }
        return error;
      });
    axios
      .get(
        URL + "grupos/empresa/" + idEmpresa() + "/getAll",
        getAuthorizationHeader()
      )
      .then((res) => {
        if (res.data.error == false) {
          this.setState({ gruposUsuarios: res.data.datos });
        }
      }, error => {
        if (error.response.status === 401) {
          logout();
        }
        return error;
      });
  }

  validarExtensionDocumento = () => {
    let datos = this.state.tipoDocumento;
    let extension = datos.find(tipo => tipo.id == this.state.tipoDocumentoID)
    if (extension) {
      return extension.formato == "XML";
    }
    return false
  }

  formatFileSize = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + sizes[i];
  }

  handleArchivo = (archivo) => {
    if (!this.state.tipoDocumentoID) {
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          tipoDocumentoID: "Debe seleccionar un tipo de documento primero"
        }
      }))
      mostrarErroresEnFormulario(this.state.errors)
    } else {
      this.setState({ archivoLote: archivo, nombreArchivo: archivo.name, pesoArchivoMb: this.formatFileSize(archivo.size) })
      limpiarErrorCampo("archivoLote")
    }
  }

  handleInput = (e) => {
    const name = e.target.name;
    const val = e.target.value;
    this.setState(prevState => ({
      errors: {
        ...prevState.errors,
        [name]: null
      },
      [name]: val,
    }))
  };

  handleChangeSelect = (e) => {
    let name = e.target.name;
    let val = e.target.value;
    let documento = this.state.tipoDocumento.find(element => element.id == val);
    if (documento)
      this.setState({
        [name]: val,
        fileErrorMsg: "",
        formatoTipoDocumentoSeleccionado: documento.formato,
        isCarpetaPorDefecto: documento.carpetaPorDefecto != "" ? true : false,
        carpetaPorDefecto: documento.carpetaPorDefecto,
        uploadDisabled: documento.carpetaPorDefecto != "" ? true : false,
        listaArchivosPermitidos: [documento.formato.toLowerCase()]
      })
    limpiarErrorCampo(name)
  }

  handleClickSeleccionColaborador = () => {
    this.setState({ mostrarAsignacion: true })
  }


  render() {

    const { mostrarAsignacion } = this.state;

    return (
      <div className="template-base">
        <header className="component-header">
          <div className="page-container">

            <BreadCrumComponent
              backUrl='/lotes/generar'
              breadcrumbs={
                [
                  { label: 'Nuevo Lote', path: '/lotes/generar' },
                  { label: 'Importar Documento', path: '' }
                ]
              }
            />
            <div className="head-area">
              <div className="caption-area">
                <h1 className="page-title"> Importar Documento </h1>
                <p className="page-description"> Complete el siguiente formulario con los datos correspondientes </p>
              </div>
            </div>
          </div>
        </header>
        {
          !mostrarAsignacion ? (
            <div className="wrapperContent">
              <div className="component-form">
                <div className="page-container">

                  <div className="component-content card">

                    {this.state.idColaborador &&
                      <div>
                        <div className="form-group">
                          <span>
                            <p className="section__description"> El documento sera enviado a: {this.state.usuarioData.nombreApellido} </p>
                          </span>
                        </div>
                        <hr />
                      </div>
                    }

                    <form onSubmit={this.subirArchivo} className="form container-sm">
                      <h4 className="section__subtitle center-text"> Cargar nuevo documento </h4>
                      <p className="section__description center-text"> Selecciona el documento a cargar </p>

                      <div className="carga-documento-section" name="archivoLote">
                        <div className="carga-documento-content">
                          <DropzoneComponent onFileSelected={this.handleArchivo} archivos_soportados={this.state.listaArchivosPermitidos} />
                        </div>
                      </div>


                      {
                        this.state.nombreArchivo &&
                        <div className="component-progress-upload">
                          <div className="contentInner">

                            <div className="icon-shape shape-xl">
                              <span className="material-symbols-outlined"> folder_zip </span>
                            </div>
                            <div className="progress-content">
                              <div className="load-info">
                                <span className="file-name">{this.state.nombreArchivo}</span>
                              </div>
                              <div className="file-info">
                                <span className="file-size">{this.state.pesoArchivoMb}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      <div className="form-group__inline">
                        <div className="form-group">
                          <input type="text" id="descripcion" name="descripcion" onChange={this.handleInput} className="form-input" placeholder="" value={this.state.descripcion} />
                          <label htmlFor="descripcion" className="form-label"> Descripción </label>
                        </div>
                        <div className="form-group">
                          <select className="form-select" id="tipoDocumentoID" name="tipoDocumentoID" onChange={this.handleChangeSelect} value={this.state.tipoDocumentoID}>
                            <option value=""> </option>
                            {this.state.tipoDocumento.map((elemento) => (
                              <option key={elemento.id} value={elemento.id}>
                                {elemento.nombre}
                              </option>
                            ))}
                          </select>
                          <label htmlFor="tipoDocumentoID" className="form-label"> Tipo de documento </label>
                        </div>

                        {
                          this.state.isCarpetaPorDefecto &&
                          <div className="form-group">
                            <input type="text" name="carpetaPorDefecto" onChange={this.handleInput} className="form-input" placeholder="" value={this.state.carpetaPorDefecto} />
                            <label htmlFor="text" className="form-label"> Carpeta por defecto </label>
                          </div>
                        }

                        {
                          this.validarExtensionDocumento() &&
                          <div className="form-group">
                            <select className="form-select" name="numeroPatronalID" onChange={this.handleInput} value={this.state.numeroPatronalID}>
                              <option key="" value="" selected></option>
                              {this.state.numeroPatronal.map((elemento) => (
                                <option value={elemento.id} key={elemento.id}>{elemento.nombre}</option>
                              ))}
                            </select>
                            <label className="form-label"> Nro. MTESS patronal </label>
                          </div>
                        }
                      </div>

                      <div className="form-actions">
                        <button onClick={() => this.props.history.push('/lotes/generar')} className="btn-medium btn-link"> Cancelar </button>
                        {this.state.idColaborador == null
                          ? <button onClick={this.handleClickSeleccionColaborador} className="btn-medium btn-primary"> Seleccionar destinatario </button>
                          : <button type="submit" className="btn-medium btn-primary"> Continuar </button>
                        }
                      </div>
                    </form>
                  </div>

                </div>
              </div>
            </div>
          ) : (
            <AsignarColaboradoresGrupos onConfirmar={this.confirmarColaborador} />
          )
        }

      </div>

    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  guardarAplicacionExterna: (value) => dispatch(guardarAplicacionExterna(value)),
  editarAplicacionExterna: (value) => dispatch(editarAplicacionExterna(value)),
  exportarDocumento: (file) => dispatch(exportarDocumento(file)),
  getUsuario: (page, size, search) => dispatch(getUsuario(page, size, search))
});

const mapStateToProps = (state) => ({
  usuariosData: state.usuariosData,
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportarDocumento);
